import { Link } from 'react-router';
import { Home as HomeIcon, Search as SearchIcon } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h1 className="text-9xl font-bold text-gray-200">404</h1>
          <h2 className="mt-4 text-3xl font-bold text-gray-900">
            Page not found
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            Sorry, we couldn't find the page you're looking for.
          </p>
          
          <div className="mt-8 flex gap-4 justify-center">
            <Link to="/" className="btn btn-primary">
              <HomeIcon className="h-4 w-4 mr-2" />
              Go Home
            </Link>
            <Link to="/search-jobs" className="btn btn-outline">
              <SearchIcon className="h-4 w-4 mr-2" />
              Search Jobs
            </Link>
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            If you believe this is an error, please{' '}
            <a href="mailto:support@example.com" className="font-medium text-primary-600 hover:text-primary-500">
              contact support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}